import React from "react";
import { Chart } from "primereact/chart";
import { MonthlyVolume } from "../../../../types/onboardingAnalytics";
import {
  COCHARGE_DARK_GREEN,
  COCHARGE_LIGHT_LIME,
} from "../../../../styles/theme_constants";
import { monthLabel } from "../../../../utils/analyticsFormat";

interface VolumeChartProps {
  months: MonthlyVolume[];
}

/**
 * New prospects against completed onboardings, per calendar month.
 *
 * Unlike the duration trend, a zero here is a real measurement — no prospects
 * arrived that month — so zeros are plotted rather than treated as gaps.
 */
const VolumeChart: React.FC<VolumeChartProps> = ({ months }) => {
  const data = {
    labels: months.map((m) => monthLabel(m.month)),
    datasets: [
      {
        label: "New prospects",
        data: months.map((m) => m.newProspects),
        backgroundColor: COCHARGE_DARK_GREEN,
        barThickness: 16,
      },
      {
        label: "Completed",
        data: months.map((m) => m.completed),
        backgroundColor: COCHARGE_LIGHT_LIME,
        barThickness: 16,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: { legend: { position: "bottom" as const } },
    scales: {
      x: { grid: { display: false } },
      y: { beginAtZero: true, ticks: { precision: 0 } },
    },
  };

  return (
    <div style={{ height: "18rem" }}>
      <Chart type="bar" data={data} options={options} />
    </div>
  );
};

export default VolumeChart;
